import DOMPurify from 'dompurify';
import { ContentState, convertFromHTML, EditorState } from 'draft-js';

/**
 * draftFromHtml
 *
 * @description
 * Convert a string (can contain HTML tags) to a populated Draft.js EditorState
 *
 * @hidden
 * example found: https://draftjs.org/docs/api-reference-data-conversion/
 *
 * @param htmlString
 */
export function draftFromHtml(htmlString: string): EditorState {
    // use sanitizeHtml library to remove any potentially malicous Html
    const sanitized = DOMPurify.sanitize(htmlString);

    const blocksFromHtml = convertFromHTML(sanitized);

    const state = ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
        blocksFromHtml.entityMap,
    );

    return EditorState.createWithContent(state);
}
